import { useMutation } from "react-query";
import { useToasts } from "react-toast-notifications";

import api from "../../../api";

const batchCardUnAssignService = async ({ batchAssignCardData, handle }) => {
  const { data } = await api.post(
    `/p/${handle}/unassign_batch_cards`,
    batchAssignCardData,
  );
  return data;
};

export const useBatchCardUnAssignMutation = () => {
  const { addToast } = useToasts();

  const [mutate, { status, error, isLoading }] = useMutation(
    batchCardUnAssignService,
    {
      onSuccess: () => {
        addToast("Success", {
          appearance: "success",
        });
      },
      onError: () => {
        addToast(
          "Failed to unassign a card, please contact support for assistance.",
          {
            appearance: "error",
          },
        );
      },
    },
  );

  return {
    mutate,
    status,
    error,
    isLoading,
  };
};
